import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedRovoServiceAgentSelfServiceSetupRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-rovo-service-agent-self-service-setup',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/rovo-service-agent/self-service-setup',
	exact: true,
};
